import api from './api';

const teamTaskAssignee = {
    getOprators(params = {}) {
        return api.query('People/api/People', {
            params,
        })
    },
    assignOprator(data) {
        return api.put('crmtt/api/Issue/Assign', data)
    }
}

export default teamTaskAssignee